var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from "react";
import { useSelector } from "react-redux";
import GenericTable from "../../../../../shared-library/components/GenericTable";
import di from "../di/serviceLocator";
import Loader from "../../../../../shared-library/components/Loader";
// export interface IPartnerRegistrationDetailsEntity {
//   partNSECMRegNo?: string;
//   partNSECMRegDate?: string;
//   partBSECMRegNo?: string;
//   partBSECMDate?: string;
//   partNSEFORegNo?: string;
//   partNSEFODate?: string;
//   partNSECDRegDate?: string;
//   partNSECDRegNo?: string;
//   partMCXRegNo?: string;
//   partMCXRegDate?: string;
//   partNCDEXRegNo?: string;
//   partNCDEXRegDate?: string;
//   arnNo?: string;
//   arNNoDate?: string;
// }
var PartnerRegistrationDetails = function (props) {
    var _a, _b;
    var _c = __read(React.useState({
        registrationDetails: [],
    }), 2), partnerRegistrationDetails = _c[0], setPartnerRegistrationDetails = _c[1];
    var selectedAcount = useSelector(function (state) { return state.Clients.ClientSearch.reducersData.selected; });
    var selectedPartner = useSelector(function (state) {
        return state.Partners.partnerSummary.reducersData.selectedPartner;
    });
    var _d = useSelector(function (state) { return state.Partners.partnerProfDemMetNomSeg.commonData; }), overviewLoader = _d.loader, errorData = _d.errorData;
    var RegistrationColumns = [
        {
            columnName: "Partner",
            key: "partnerCode",
        },
        {
            columnName: "Exchange Name",
            key: "exchangeName",
        },
        {
            columnName: "Segment",
            key: "segmentName",
        },
        {
            columnName: "Registration No.",
            key: "registrationNo",
        },
        {
            columnName: "Registration Date",
            key: "registrationDate",
        },
    ];
    var registrationData = useSelector(function (state) {
        return state.Partners.partnerProfDemMetNomSeg.reducersData.registrationDetails;
    });
    React.useEffect(function () {
        di.partnerOverview
            .getPartnerRegistrationDetails({
            AcCode: selectedPartner.accountCode,
            flg: selectedPartner.flag,
            page: 1,
            pageSize: 100,
        })
            .then(function (data) {
            if (data.registrationDetails.length) {
                setPartnerRegistrationDetails(data);
            }
        });
    }, [selectedPartner]);
    React.useEffect(function () {
        if (registrationData !== null && registrationData !== undefined) {
            setPartnerRegistrationDetails(registrationData);
        }
    }, [registrationData]);
    return (React.createElement(React.Fragment, null, overviewLoader ? (React.createElement("div", { className: "position-relative client-loader" },
        React.createElement(Loader, null))) : (React.createElement("section", { id: "profile-details", className: "section-padding element" },
        React.createElement("label", { className: "DMSanBold_18_700 txt_blackOne1 label-padding" }, "Registration Details"),
        React.createElement(GenericTable, { columns: RegistrationColumns, data: partnerRegistrationDetails.registrationDetails, parentClassName: "salestableParentClass", tableClassName: "salestableclass", message: {
                msg: "No Data Found",
                show: partnerRegistrationDetails === null ||
                    ((_a = partnerRegistrationDetails.registrationDetails) === null || _a === void 0 ? void 0 : _a.length) ===
                        undefined ||
                    ((_b = partnerRegistrationDetails.registrationDetails) === null || _b === void 0 ? void 0 : _b.length) === 0
                    ? true
                    : false,
                icon: "",
            } })))));
};
export default PartnerRegistrationDetails;
